import React from "react";
import ClickableUrlField from "@/components/controls/ClickableUrlField";
import { cn } from "@/utils/utils";
import { FIELD_CLASSNAME, HALF_WRAPPER_CLASSNAME } from "../shared";
import { asString, ControlProps } from "../types";

export const UrlControl: React.FC<ControlProps> = ({ value, onChange }) => (
  <div
    className={cn(
      HALF_WRAPPER_CLASSNAME,
      FIELD_CLASSNAME,
      "flex items-center h-9 pr-2 bg-surface-field-default"
    )}
  >
    <div className="flex-1 min-w-0">
      <ClickableUrlField
        value={asString(value)}
        alwaysShowEditButton
        onChange={onChange}
      />
    </div>
  </div>
);
